import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=62b8fb6b&scoped=true"
import script from "./AccordionCard.vue?vue&type=script&lang=js"
export * from "./AccordionCard.vue?vue&type=script&lang=js"
import style0 from "./AccordionCard.vue?vue&type=style&index=0&id=62b8fb6b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b8fb6b",
  null
  
)

export default component.exports